import { getConfig } from '@edx/frontend-platform';


import { useIntl } from '@edx/frontend-platform/i18n';
import messages from '../messages'; // Import the messages file

import React, { useState } from 'react';
import '../Componentsadminpanel/BulkEnrollTable.css';  // Ensure the correct path for your CSS file

const Bulkenroll = () => {
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const { formatMessage } = useIntl();
  const [file, setFile] = useState(null);
  const [isFileValid, setIsFileValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);  // For loading state during file upload

  // Get CSRF token
  const getCsrfToken = () => {
    return document.cookie.split('; ')
      .find(row => row.startsWith('csrftoken='))
      ?.split('=')[1];
  };

  // Handle file selection
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.name.endsWith('.csv')) {
      setFile(selectedFile);
      setIsFileValid(true);
    } else {
      setFile(null);
      setIsFileValid(false);
    }
  };

  // API Call to submit CSV file
  const submitCsv = async () => {
    if (!file) {
      alert(formatMessage(messages.uploadCsvFirst));
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    setIsLoading(true);  // Show loading state

    try {
      const response = await fetch(`${getConfig().LMS_BASE_URL}/api/bulk-enroll-csv/`, {
        method: 'POST',
        body: formData,
        credentials: 'include',
        headers: {
          'X-CSRFToken': getCsrfToken(),
        },
      });

      const result = await response.json();

      if (response.ok) {
        setShowSuccessModal(true);  // Show success modal
      } else {
        setShowErrorModal(true);  // Show error modal
      }
    } catch (error) {
      console.error('Error uploading CSV:', error);
      setShowErrorModal(true);  // Show error modal
    } finally {
      setIsLoading(false);  // Hide loading state
    }
  };

  // Handle clicking on "Bulk Enroll" button
  const handleBulkEnrollClick = () => {
    console.log("Bulk Enroll button clicked!"); // Debugging line
    setShowUploadModal(true);  // Open the upload modal
  };

  // Handle submit (open the confirmation modal)
  const handleSubmit = () => {
    setShowUploadModal(false);
    setShowConfirmationModal(true);
  };

  // Handle confirmation (Yes, make the API call)
  const handleConfirm = async () => {
    setShowConfirmationModal(false); // Close confirmation modal immediately
    await submitCsv();  // Submit the CSV file
  };

  // Handle cancellation (No, clear the form)
  const handleCancel = () => {
    setFile(null);
    setShowUploadModal(false);
    setShowConfirmationModal(false);
    setShowSuccessModal(false);
    setShowErrorModal(false);
  };

  return (
    <div>
      <h1>{formatMessage(messages.bulkEnrollment)}</h1>
  
      <button className="bulkenroll-btn" onClick={handleBulkEnrollClick}>
        {formatMessage(messages.bulkEnrollButton)}
      </button>
  
      {/* Upload CSV Modal */}
      {showUploadModal && (
        <div className="modal">
          <div className="modal-content">
            <div className="modal-header">
              {formatMessage(messages.uploadCSVHeader)}
            </div>
            <div className="modal-body">
              <div className="dotted-border">
                <label htmlFor="csv-file" title="Choose a CSV file./Elige un archivo CSV."  
                >
                  {formatMessage(messages.uploadCSVLabel)}
                </label>
                <input
                  type="file"
                  id="csv-file"
                  aria-hidden
                  className='file-selector'
                  accept=".csv"
                  hidden
                  onChange={handleFileChange}
                /> 
              </div>
              {file && <p>{formatMessage(messages.fileName, { fileName: file.name })}</p>}
              {!isFileValid && file && (
                <p style={{ color: 'red' }}>
                  {formatMessage(messages.invalidFile)}
                </p>
              )}
            </div>
            <div className="modal-footer">
              <button onClick={handleCancel}>{formatMessage(messages.cancel)}</button>
              <button onClick={handleSubmit} disabled={!isFileValid}>
                {formatMessage(messages.submit)}
              </button>
            </div>
            <label className="bulk-user-label">
              {formatMessage(messages.sampleFile)}
              <span>
                <a href={`${getConfig().LMS_BASE_URL}/media/bulk_user_enroll_file.csv`} download>
                  <span> {formatMessage(messages.clickHere)} </span>
                </a>
              </span>
              {formatMessage(messages.toDownload)}
            </label>
          </div>
        </div>
      )}
  
      {/* Confirmation Modal */}
      {showConfirmationModal && (
        <div className="modal">
          <div className="modal-content">
            <div className="modal-header">
              {formatMessage(messages.confirmation)}
            </div>
            <div className="modal-body">
              <p>{formatMessage(messages.confirmBulkEnroll)}</p>
            </div>
            <div className="modal-footer">
              <button onClick={handleCancel}>{formatMessage(messages.no)}</button>
              <button onClick={handleConfirm}>{formatMessage(messages.yes)}</button>
            </div>
          </div>
        </div>
      )}
  
      {/* Success Modal */}
      {showSuccessModal && (
        <div className="modal">
          <div className="modal-content">
            <div className="modal-header">
              {formatMessage(messages.success)}
            </div>
            <div className="modal-body">
              <p>{formatMessage(messages.uploadSuccess)}</p>
            </div>
            <div className="modal-footer">
              <button onClick={handleCancel}>{formatMessage(messages.close)}</button>
            </div>
          </div>
        </div>
      )}
  
      {/* Error Modal */}
      {showErrorModal && (
        <div className="modal">
          <div className="modal-content">
            <div className="modal-header">
              {formatMessage(messages.error)}
            </div>
            <div className="modal-body">
              <p>{formatMessage(messages.uploadError)}</p>
            </div>
            <div className="modal-footer">
              <button onClick={handleCancel}>{formatMessage(messages.close)}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
  
};

export default Bulkenroll;
